/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */
export const featureGateKeys = {
  /**
   * PAU_AI_IMPACT_AND_CONTEXT_TAGS
   * @link https://hello.atlassian.net/browse/FD-202623
   * @description Controls visibility of AI-generated Impact rating and
   * Contextual tags columns on the list and details pages.
   * OFF by default — safe to merge at any time.
   * @returns true if the AI Impact and Contextual tags columns should be shown
   */
  aiImpactAndContextTags: 'public_app_updates_ai_impact_and_context_tags',
  /**
   * PAU_CONTEXTUAL_TAGS_BETA
   * @link https://switcheroo.atlassian.com/ui/gates/40c3b4b3-4572-49cb-9572-f41a4038194a/key/pau_contextual_tags_beta
   * @description Controls visibility of AI-generated Contextual tags after the
   * parent AI Impact and Contextual tags gate is enabled.
   * OFF by default while Contextual tags remain in beta.
   */
  contextualTagsBeta: 'pau_contextual_tags_beta',
  /**
   * @deprecated A fake gate key used only in unit tests to exercise the fg() utility.
   * Not a real Switcheroo gate — do not use in production code.
   */
  testOnly: 'test-gate-for-unit-tests',
} as const;

export type FeatureGateValue =
  (typeof featureGateKeys)[keyof typeof featureGateKeys];
